export const CLASSES_DO_RSCORE = {
  excelente: {
    color: "#1d4ed8",
    bg: "#eff6ff",
    border: "#93c5fd",
    tag: "processing",
  },
  boa: {
    color: "#15803d",
    bg: "#f0fdf4",
    border: "#86efac",
    tag: "success",
  },
  regular: {
    color: "#b45309",
    bg: "#fffbeb",
    border: "#fde68a",
    tag: "warning",
  },
  "abaixo do potencial": {
    color: "#c2410c",
    bg: "#fff7ed",
    border: "#fdba74",
    tag: "orange",
  },
  crítica: {
    color: "#b91c1c",
    bg: "#fef2f2",
    border: "#fca5a5",
    tag: "error",
  },
};

export function classeDoRscore(classificacao) {
  return CLASSES_DO_RSCORE[classificacao] || CLASSES_DO_RSCORE.regular;
}

export function corDaDimensao(score) {
  if (score >= 85) return "#60a5fa";
  if (score >= 70) return "#4ade80";
  if (score >= 55) return "#fbbf24";
  if (score >= 40) return "#fb923c";
  return "#f87171";
}
